import React, { useState } from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AuthModal from './components/AuthModal';

import Home from './pages/Home';
import Browse from './pages/Browse';
import TemplateDetail from './pages/TemplateDetail';
import DesignerProfile from './pages/DesignerProfile';
import Dashboard from './pages/Dashboard';
import Upload from './pages/Upload';
import Library from './pages/Library';
import Settings from './pages/Settings';
import Competitions from './pages/Competitions';
import CompetitionDetail from './pages/CompetitionDetail';
import Community from './pages/Community';
import About from './pages/About';

import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import ScrollToTop from './components/ScrollToTop';

function Layout() {
  const [isAuthOpen, setAuthOpen] = useState(false);

  return (
    <div className="app-layout">
      <ScrollToTop />
      <Navbar onOpenAuth={() => setAuthOpen(true)} />
      <main className="main-content">
        <Outlet context={{ setAuthOpen }} />
      </main>
      <Footer />
      <AuthModal isOpen={isAuthOpen} onClose={() => setAuthOpen(false)} />
    </div>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <CartProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="browse" element={<Browse />} />
              <Route path="resources" element={<Browse />} />
              <Route path="competitions" element={<Competitions />} />
              <Route path="competitions/:id" element={<CompetitionDetail />} />
              <Route path="community" element={<Community />} />
              <Route path="about" element={<About />} />
              <Route path="template/:slug" element={<TemplateDetail />} />
              <Route path="designer/:username" element={<DesignerProfile />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="dashboard/upload" element={<Upload />} />
              <Route path="library" element={<Library />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </CartProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
